import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { Rights } from 'src/app/models/enums/rights';
import { IBoxAccessibility } from 'src/app/models/interfaces/box-accessibility.interface';
import { IBox } from 'src/app/models/interfaces/box.interface';
import { MemoryService } from 'src/app/services/memory.service';
import { BoxAccessibilityComponent } from '../box-accessibility/box-accessibility.component';
import { BoxDetailContext } from '../box-detail-context';
import { BoxFormComponent } from '../box-form/box-form.component';

@Component({
    selector: 'app-box-detail',
    templateUrl: './box-detail.component.html',
    styleUrls: ['./box-detail.component.scss'],
    imports: [MatTabsModule, BoxFormComponent, BoxAccessibilityComponent]
})
export class BoxDetailComponent implements OnInit {
    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Reference au composant groupe d'onglets.
     */
    @ViewChild(MatTabGroup)
    tabGroup: MatTabGroup;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public boxUpdated: EventEmitter<IBox> = new EventEmitter();

    /**
     * Emis lorsque le formulaire d'accessibilité est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public accessibilitiesUpdated: EventEmitter<IBoxAccessibility[]> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Contexte du formulaire.
     */
    public _context: BoxDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<BoxDetailContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: BoxDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    /** Indique s'il faut affiocher les accessibilité */
    public displayAccessibilities = true;

    constructor(private memoryService: MemoryService) {
        this.displayAccessibilities = !!this.memoryService.getConnectedUser().hasRight(Rights.BoxEdit);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont sauvegardés.
     * @param box: Infos de la bannette modifiée.
     */
    public onBoxUpdated(box: IBox) {
        this.boxUpdated.emit(box);
    }

    /** Appellé lorsque des changements sur le formulaire "Accessibilité" sont sauvegardés.*/
    public onAccessibilitiesUpdated(accessibilities: IBoxAccessibility[]) {
        this.accessibilitiesUpdated.emit(accessibilities);
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont annulés.
     * @param user: Infos de l'article modifié.
     */
    public onCanceled(value: boolean) {
        this.canceled.emit(value);
    }
}
